import { ReferenceFieldRowFormat } from './reference-field-row-format.interface';
import { SubForm } from './sub-form.interface';

export class ReferenceField {
  id: number | string;
  dataViewColumn: string;
  rowFormat: ReferenceFieldRowFormat;
  subForm?: SubForm;
  disabled?: boolean;
}



// WEBPACK FOOTER //
// ./src/submodules/sellions_forms/projects/forms/src/lib/interfaces/reference-field.interface.ts